/* ============================================
   LOR AINÉ 1986 - Theme JavaScript
   ============================================ */

// ========== SHOPIFY CONSTANTS & UTILITIES ==========
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

function debounce(fn, wait) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

function formatMoney(cents) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var parsed = parseInt(cents);
  if (isNaN(parsed)) return '$0.00';
  const value = (parsed / 100).toFixed(2);
  return '$' + value;
}

// Shopify object extension
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var parsed = parseInt(cents);
  if (isNaN(parsed)) return '$0.00';
  const value = (parsed / 100).toFixed(2);
  return '$' + value;
};

// PubSub for cart updates
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {

  // ========== SCROLL REVEAL ANIMATIONS ==========
  const revealElements = document.querySelectorAll('.reveal, .reveal-left');

  if (!Shopify.designMode) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -30px 0px'
    });

    revealElements.forEach(el => revealObserver.observe(el));
  }

  // ========== STAGGER ANIMATION INDEX ==========
  document.querySelectorAll('.stagger').forEach(container => {
    container.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.setProperty('--index', i);
    });
  });

  // ========== NAVBAR SCROLL EFFECT ==========
  const nav = document.getElementById('nav');
  let lastScroll = 0;
  let navTicking = false;

  if (nav && nav.dataset.sticky === 'true') {
    window.addEventListener('scroll', () => {
    if (!navTicking) {
      requestAnimationFrame(() => {
        const currentScroll = window.scrollY;
        if (nav) {
          if (currentScroll > 50) {
            nav.classList.add('scrolled');
          } else {
            nav.classList.remove('scrolled');
          }
        }
        lastScroll = currentScroll;
        navTicking = false;
      });
      navTicking = true;
    }
  }, { passive: true });
  } // end sticky nav

  // Mobile navigation is handled by inline JS in header.liquid (nav-drawer-trigger / navDrawer)

  // ========== PARALLAX EFFECT ==========
  const parallaxImage = document.getElementById('parallaxImage');
  const featuredSection = document.getElementById('featuredSection');

  if (parallaxImage && featuredSection) {
    let isVisible = false;
    let parallaxTicking = false;

    // 1. Observe visibility to avoid running logic when off-screen
    const sectionObserver = new IntersectionObserver((entries) => {
      isVisible = entries[0].isIntersecting;
    }, { rootMargin: '100px 0px' });

    sectionObserver.observe(featuredSection);

    // 2. Optimized scroll handler
    window.addEventListener('scroll', () => {
      if (!isVisible || parallaxTicking) return;

      requestAnimationFrame(() => {
        const rect = featuredSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Simple linear interpolation
        const scrolled = (windowHeight - rect.top) / (windowHeight + rect.height);

        // Clamp value between 0 and 1 for safety
        const safeScrolled = Math.max(0, Math.min(1, scrolled));
        const translateY = (safeScrolled - 0.5) * 100;

        parallaxImage.style.transform = `translateY(${translateY}px)`;

        parallaxTicking = false;
      });
      parallaxTicking = true;
    }, { passive: true });
  }

  // ========== HERO TITLE LETTER ANIMATION ==========
  const heroTitle = document.getElementById('heroTitle');

  if (heroTitle) {
    // Only run letter animation if heading is plain text (no child elements)
    if (heroTitle.children.length === 0) {
      const text = heroTitle.textContent;
      heroTitle.innerHTML = '';

      text.split('').forEach((letter, i) => {
        const span = document.createElement('span');
        span.className = 'letter';
        span.textContent = letter === ' ' ? '\u00A0' : letter;
        span.style.animationDelay = `${0.5 + i * 0.08}s`;
        heroTitle.appendChild(span);
      });
    }
  }

  // ========== SMOOTH SCROLL FOR ANCHOR LINKS ==========
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;

      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });

  // ========== PRODUCT MEDIA GALLERY ==========
  const mainImageContainer = document.querySelector('.product-main-image');
  const mainImage = document.getElementById('mainProductImage');
  const mainVideo = document.getElementById('mainProductVideo');
  const thumbnails = document.querySelectorAll('.product-thumb');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const mediaType = this.dataset.mediaType;

      if (mediaType === 'video') {
        // Switch to hosted video
        if (mainImage) mainImage.style.display = 'none';
        const existingVideo = mainImageContainer.querySelector('.product-video, .product-external-video');
        if (existingVideo) existingVideo.remove();
        const video = document.createElement('video');
        video.className = 'product-video';
        video.src = this.dataset.videoSrc;
        video.poster = this.dataset.poster;
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.style.cssText = 'width:100%;height:auto;display:block;';
        mainImageContainer.insertBefore(video, mainImageContainer.querySelector('.image-zoom-lens'));
      } else if (mediaType === 'external_video') {
        // Switch to external video (YouTube/Vimeo)
        if (mainImage) mainImage.style.display = 'none';
        const existingVideo = mainImageContainer.querySelector('.product-video, .product-external-video');
        if (existingVideo) existingVideo.remove();
        const template = document.querySelector('template[data-external-video="' + this.dataset.externalVideoId + '"]');
        if (template) {
          const wrapper = document.createElement('div');
          wrapper.className = 'product-external-video';
          wrapper.innerHTML = template.innerHTML;
          mainImageContainer.insertBefore(wrapper, mainImageContainer.querySelector('.image-zoom-lens'));
        }
      } else {
        // Switch to image
        const existingVideo = mainImageContainer.querySelector('.product-video, .product-external-video');
        if (existingVideo) existingVideo.remove();
        if (mainImage) {
          mainImage.style.display = '';
          mainImage.src = this.dataset.image;
          var zoomSrc = (this.dataset.zoom) || this.dataset.image.replace('width=1200', 'width=2400');
          mainImage.dataset.zoomSrc = zoomSrc;
        }
      }
    });
  });

  // ========== MOBILE SWIPE GALLERY ==========
  (function() {
    var gallery = document.querySelector('.product-gallery');
    var imageContainer = document.querySelector('.product-main-image');
    var thumbs = document.querySelectorAll('.product-thumb');
    var dots = document.querySelectorAll('.product-gallery-dot');
    if (!imageContainer || thumbs.length < 2) return;

    var currentIndex = 0;
    var startX = 0;
    var startY = 0;
    var diffX = 0;
    var swiping = false;

    function goToSlide(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;
      thumbs[index].click();
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === index);
      });
    }

    imageContainer.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    imageContainer.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      diffX = e.touches[0].clientX - startX;
      var diffY = e.touches[0].clientY - startY;
      // If horizontal swipe is dominant, prevent vertical scroll
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
        e.preventDefault();
      }
    }, { passive: false });

    imageContainer.addEventListener('touchend', function() {
      if (!swiping) return;
      swiping = false;
      if (Math.abs(diffX) > 50) {
        if (diffX < 0) {
          goToSlide(currentIndex + 1); // swipe left = next
        } else {
          goToSlide(currentIndex - 1); // swipe right = prev
        }
      }
      diffX = 0;
    }, { passive: true });

    // Sync dots when thumbnails are clicked directly
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        currentIndex = i;
        dots.forEach(function(dot, j) {
          dot.classList.toggle('active', j === i);
        });
      });
    });

    // Dot clicks
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToSlide(i);
      });
    });
  })();

  // ========== QUANTITY SELECTOR (product page only — cart drawer uses event delegation) ==========
  document.querySelectorAll('.qty-btn').forEach(btn => {
    // Skip buttons inside the cart drawer — handled by delegated listener
    if (btn.closest('#cart-drawer')) return;
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.qty-input');
      const currentValue = parseInt(input.value) || 1;

      if (this.dataset.action === 'increase') {
        input.value = currentValue + 1;
      } else if (this.dataset.action === 'decrease' && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // ========== ACCORDION ==========
  document.querySelectorAll('.detail-header').forEach(header => {
    header.addEventListener('click', function () {
      const item = this.parentElement;
      const isOpen = item.classList.contains('open');

      // Optional: close other accordions
      // document.querySelectorAll('.detail-item.open').forEach(openItem => {
      //   openItem.classList.remove('open');
      // });

      item.classList.toggle('open');
      this.setAttribute('aria-expanded', !isOpen);
    });
  });

  // ========== FILTER TABS ==========
  const filterTabsContainer = document.querySelector('.filter-tabs');
  const filterTabs = document.querySelectorAll('.filter-tab');

  if (filterTabsContainer) {
    const baseUrl = filterTabsContainer.dataset.baseUrl;

    filterTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const filter = this.dataset.filter;
        let newUrl = baseUrl;

        if (filter !== 'all') {
          // If url already ends in slash, don't add another, otherwise do.
          // Standardize: remove trailing slash from base if present
          const cleanBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
          newUrl = `${cleanBase}/${filter}`;
        }

        window.location.href = newUrl;
      });
    });
  }

  // ========== SORT SELECT ==========
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ========== VIEW TOGGLE ==========
  const viewToggles = document.querySelectorAll('.view-toggle');
  const productsGrid = document.getElementById('productsGrid');

  viewToggles.forEach(toggle => {
    toggle.addEventListener('click', function () {
      viewToggles.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-pressed', 'true');

      var view = this.dataset.view;
      if (productsGrid) {
        if (view === 'list') {
          productsGrid.classList.add('list-view');
        } else {
          productsGrid.classList.remove('list-view');
        }
      }
    });
  });

  // ========== CART DRAWER LOGIC ==========
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');

  function openCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.add('open');
      cartDrawerOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      // Focus the close button for accessibility
      var closeBtn = cartDrawer.querySelector('.cart-drawer-close');
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 100);
    }
  }

  function closeCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.remove('open');
      cartDrawerOverlay.classList.remove('open');
      document.body.style.overflow = '';
      // Return focus to cart trigger
      var cartTrigger = document.querySelector('.nav-cart');
      if (cartTrigger) cartTrigger.focus();
    }
  }

  // Custom Events
  document.addEventListener('cart-drawer:open', openCartDrawer);
  document.addEventListener('cart-drawer:close', closeCartDrawer);

  // Close Listeners
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawer) {
    cartDrawer.addEventListener('click', (e) => {
      if (e.target.closest('.cart-drawer-close')) closeCartDrawer();
      if (e.target.closest('.close-drawer-btn')) closeCartDrawer();
    });
  }

  // Escape key closes cart drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
    // Focus trap — keep Tab cycling within open cart drawer
    if (e.key === 'Tab' && cartDrawer && cartDrawer.classList.contains('open')) {
      var focusable = cartDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  // Fetch Cart Drawer HTML
  async function fetchCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newDrawer = html.getElementById('cart-drawer');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;

        // Update Cart Bubble
        const newCount = html.querySelector('.cart-drawer-count')?.textContent;
        const bubble = document.querySelector('.nav-cart-count');
        if (bubble && newCount) bubble.textContent = newCount;
      }
    } catch (err) {
      console.error('Error fetching cart drawer:', err);
    }
  }

  // Add to Cart Handler
  const addToCartForms = document.querySelectorAll('.product-form');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = '...';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const response = await fetch('/cart/add.js', config);

        if (response.ok) {
          await fetchCartDrawer();
          openCartDrawer();
          submitBtn.textContent = originalText; // Reset text immediately
        } else {
          throw new Error('Failed to add');
        }
      } catch (error) {
        console.error(error);
        submitBtn.textContent = 'Error';
      } finally {
        submitBtn.disabled = false;
        setTimeout(() => { if (submitBtn.textContent === 'Error') submitBtn.textContent = originalText; }, 2000);
      }
    });
  });

  // Drawer Event Delegation (Quantity & Remove)
  if (cartDrawer) {
    cartDrawer.addEventListener('click', async (e) => {
      // Remove Item
      const removeLink = e.target.closest('.drawer-item-remove');
      if (removeLink) {
        e.preventDefault();
        const line = removeLink.dataset.line;
        await updateCartItem(line, 0);
        return;
      }

      // Quantity Buttons
      const qtyBtn = e.target.closest('.qty-btn');
      if (qtyBtn) {
        const input = qtyBtn.parentElement.querySelector('.qty-input');
        const line = input.dataset.line;
        let qty = parseInt(input.value);

        if (qtyBtn.dataset.action === 'increase') qty++;
        if (qtyBtn.dataset.action === 'decrease') qty--;

        if (qty >= 0) await updateCartItem(line, qty);
      }
    });

    cartDrawer.addEventListener('change', async (e) => {
      if (e.target.classList.contains('qty-input')) {
        const line = e.target.dataset.line;
        const qty = parseInt(e.target.value);
        if (qty >= 0) await updateCartItem(line, qty);
      }
    });
  }

  let cartUpdateBusy = false;
  async function updateCartItem(line, quantity) {
    if (cartUpdateBusy) return;
    cartUpdateBusy = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: parseInt(quantity) })
      });
      if (res.ok) {
        await fetchCartDrawer();
      }
    } catch (err) {
      console.error(err);
    } finally {
      cartUpdateBusy = false;
    }
  }

  // ========== VARIANT SELECTION ==========
  const variantButtons = document.querySelectorAll('.variant-option-btn');
  const variantJsonEl = document.getElementById('product-variants-json');
  const variantIdInput = document.getElementById('product-variant-id');
  const addToCartBtn = document.querySelector('.add-to-cart');
  const priceDisplay = document.querySelector('[data-product-price]');

  if (variantButtons.length && variantJsonEl) {
    const variants = JSON.parse(variantJsonEl.textContent);
    const optionSelectors = document.querySelectorAll('.variant-option');

    // Get current selections
    function getCurrentOptions() {
      const options = [];
      optionSelectors.forEach(selector => {
        const activeBtn = selector.querySelector('.variant-option-btn.active');
        if (activeBtn) {
          options.push(activeBtn.dataset.value);
        }
      });
      return options;
    }

    // Find variant by options
    function findVariant(options) {
      return variants.find(variant => {
        return variant.options.every((opt, i) => opt === options[i]);
      });
    }

    // Update UI based on selected variant
    function updateVariant(variant) {
      if (!variant) return;

      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Update price using DOM API (H9 — avoid innerHTML)
      if (priceDisplay) {
        priceDisplay.textContent = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const compare = document.createElement('span');
          compare.className = 'product-price--compare';
          compare.textContent = formatMoney(variant.compare_at_price);
          priceDisplay.appendChild(compare);
        }
        priceDisplay.appendChild(document.createTextNode(formatMoney(variant.price)));
      }

      // Update product image when variant has a specific image
      const mainImage = document.getElementById('mainProductImage');
      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src.replace(/(\.\w+)\?/, '_1200x$1?');
        mainImage.alt = variant.featured_image.alt || variant.title;
        // Highlight matching thumbnail
        document.querySelectorAll('.product-thumb').forEach(thumb => {
          thumb.classList.toggle('active', thumb.dataset.image && variant.featured_image.src.includes(thumb.dataset.image.split('?')[0].split('_').slice(0,-1).join('_')));
        });
      }

      // Update button state
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
        }
      }
    }

    // Handle variant button clicks
    variantButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        // Update active state within this option group
        const parent = this.closest('.variant-options');
        parent.querySelectorAll('.variant-option-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        // Find and update to new variant
        const currentOptions = getCurrentOptions();
        const variant = findVariant(currentOptions);
        if (variant) {
          updateVariant(variant);
        } else {
          // No matching variant — disable add to cart
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.variantStrings?.unavailable || 'Unavailable';
          }
        }
      });
    });
  }

  // ========== REVEAL ANIMATION SAFETY NET ==========
  // In Shopify editor or if IntersectionObserver doesn't fire, force visibility after timeout
  if (Shopify.designMode) {
    // Editor mode: make everything visible immediately
    document.querySelectorAll('.reveal, .reveal-left').forEach(el => {
      el.classList.add('visible');
    });
  } else {
    // Live site: safety net — if elements haven't animated in after 4 seconds, force them
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.visible), .reveal-left:not(.visible)').forEach(el => {
        el.classList.add('visible');
      });
    }, 4000);
  }

  // C4: Flag that theme.js has loaded — prevents duplicate inline handlers
  window.__themeJsLoaded = true;

});

// ========== PREDICTIVE SEARCH ==========
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.abortController = null;

    if (!this.input) return;

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  onFocus() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) return;
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // Abort any in-flight request
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    this.predictiveSearchResults.setAttribute('loading', 'true');

    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        if (error.name === 'AbortError') return; // Expected — don't log aborts
        this.close();
        console.error('Predictive search error:', error);
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.predictiveSearchResults.innerHTML = '';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);


// ========== SHOPIFY DESIGN MODE: SECTION LIFECYCLE ==========
// Re-initialises JS-driven interactivity whenever the Theme Editor
// reloads, selects, deselects, or reorders a section / block.

function reinitSection(sectionEl) {
  if (!sectionEl) return;

  // Scroll-reveal animations
  if (Shopify.designMode) {
    // Editor mode: make all reveals visible immediately
    sectionEl.querySelectorAll('.reveal, .reveal-left').forEach(el => {
      el.classList.add('visible');
    });
  } else {
    sectionEl.querySelectorAll('.reveal, .reveal-left').forEach(el => {
      const obs = new IntersectionObserver((entries, observer) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
      obs.observe(el);
    });
  }

  sectionEl.querySelectorAll('.stagger').forEach(container => {
    container.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.setProperty('--index', i);
    });
  });

  // Product thumbnails
  sectionEl.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImage = sectionEl.querySelector('#mainProductImage');
      if (mainImage) mainImage.src = this.dataset.image;
      sectionEl.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Quantity buttons
  sectionEl.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.quantity-selector').querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') val++;
      else if (this.dataset.action === 'decrease' && val > 1) val--;
      input.value = val;
    });
  });

  // Accordion / detail toggles
  sectionEl.querySelectorAll('.detail-header').forEach(header => {
    header.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const content = this.nextElementSibling;
      if (content) {
        content.style.maxHeight = expanded ? null : content.scrollHeight + 'px';
      }
    });
  });

  // Filter tabs (collection page)
  sectionEl.querySelectorAll('.filter-tab').forEach(tab => {
    tab.addEventListener('click', function () {
      sectionEl.querySelectorAll('.filter-tab').forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');
    });
  });

  // Product form submit (AJAX add to cart)
  sectionEl.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = '...';
      submitBtn.disabled = true;
      try {
        const formData = new FormData(form);
        const config = { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: formData };
        const response = await fetch('/cart/add.js', config);
        if (response.ok) {
          const cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer) {
            const res = await fetch('/?section_id=cart-drawer');
            const text = await res.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newDrawer = html.getElementById('cart-drawer');
            if (newDrawer) cartDrawer.innerHTML = newDrawer.innerHTML;
            const newCount = html.querySelector('.cart-drawer-count')?.textContent;
            const bubble = document.querySelector('.nav-cart-count');
            if (bubble && newCount) bubble.textContent = newCount;
            cartDrawer.classList.add('open');
            const overlay = document.getElementById('cart-drawer-overlay');
            if (overlay) overlay.classList.add('open');
            document.body.style.overflow = 'hidden';
          }
          submitBtn.textContent = originalText;
        } else {
          throw new Error('Failed to add');
        }
      } catch (error) {
        console.error(error);
        submitBtn.textContent = 'Error';
      } finally {
        submitBtn.disabled = false;
        setTimeout(() => { if (submitBtn.textContent === 'Error') submitBtn.textContent = originalText; }, 2000);
      }
    });
  });

  // FAQ toggles
  sectionEl.querySelectorAll('.faq-toggle').forEach(toggle => {
    toggle.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      if (item) item.classList.toggle('open');
    });
  });

  // Variant picker (only if product variants JSON exists in section)
  const variantsJson = sectionEl.querySelector('#product-variants-json');
  const variantButtons = sectionEl.querySelectorAll('.variant-option-btn');
  const variantIdInput = sectionEl.querySelector('#product-variant-id');

  if (variantsJson && variantButtons.length > 0 && variantIdInput) {
    let variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { variants = []; }

    function getCurrentOptions() {
      const groups = sectionEl.querySelectorAll('.variant-option');
      return Array.from(groups).map(group => {
        const active = group.querySelector('.variant-option-btn.active');
        return active ? active.dataset.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(v =>
        v.options.every((opt, i) => options[i] === null || opt === options[i])
      );
    }

    variantButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        const parent = this.closest('.variant-options');
        parent.querySelectorAll('.variant-option-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        const variant = findVariant(getCurrentOptions());
        if (variant) {
          variantIdInput.value = variant.id;
          const priceDisplay = sectionEl.querySelector('[data-product-price]');
          const addToCartBtn = sectionEl.querySelector('.add-to-cart');
          if (priceDisplay) {
            priceDisplay.textContent = '';
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const compare = document.createElement('span');
              compare.className = 'product-price--compare';
              compare.textContent = Shopify.formatMoney(variant.compare_at_price);
              priceDisplay.appendChild(compare);
            }
            priceDisplay.appendChild(document.createTextNode(Shopify.formatMoney(variant.price)));
          }
          if (addToCartBtn) {
            addToCartBtn.disabled = !variant.available;
            addToCartBtn.textContent = variant.available
              ? (window.variantStrings?.addToCart || 'Add to Cart')
              : (window.variantStrings?.soldOut || 'Sold Out');
          }
        } else {
          // No matching variant in reinit context
          const addToCartBtn = sectionEl.querySelector('.add-to-cart');
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.variantStrings?.unavailable || 'Unavailable';
          }
        }
      });
    });
  }
}

// Section lifecycle events for Theme Editor
document.addEventListener('shopify:section:load', function (event) {
  reinitSection(event.target);
});

document.addEventListener('shopify:section:unload', function (event) {
  // Cleanup: disconnect any observers for this section
  const reveals = event.target.querySelectorAll('.reveal.visible, .reveal-left.visible');
  reveals.forEach(el => el.classList.remove('visible'));
});

document.addEventListener('shopify:section:select', function (event) {
  reinitSection(event.target);
});

document.addEventListener('shopify:section:deselect', function () {
  // Close any open drawers
  var navDrawer = document.getElementById('navDrawer');
  var drawerOverlay = document.getElementById('drawerOverlay');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-drawer-overlay');
  if (navDrawer) navDrawer.classList.remove('open');
  if (drawerOverlay) drawerOverlay.classList.remove('visible');
  if (cartDrawer) cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
  document.body.classList.remove('drawer-open');
});

document.addEventListener('shopify:block:select', function (event) {
  // Scroll the selected block into view and expand if accordion
  const block = event.target;
  if (block) {
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const header = block.querySelector('.detail-header');
    if (header && header.getAttribute('aria-expanded') !== 'true') {
      header.click();
    }
  }
});

document.addEventListener('shopify:block:deselect', function (event) {
  // Collapse accordion if it was expanded by block:select
  const block = event.target;
  if (block) {
    const header = block.querySelector('.detail-header');
    if (header && header.getAttribute('aria-expanded') === 'true') {
      header.click();
    }
  }
});

/* ═══════════════════════════════════════
   PHASE 2 — Scroll Reveal Animations
   ═══════════════════════════════════════ */

(function() {
  // Only run if animations are desired (check body attribute set by theme.liquid)
  if (document.body.dataset.animationsReveal === 'false') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Mark all main content sections for animation
  var sections = document.querySelectorAll('main > .shopify-section > section, main > .shopify-section > div');
  sections.forEach(function(section) {
    section.classList.add('animate-on-scroll');
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  sections.forEach(function(section) {
    observer.observe(section);
  });
})();

/* ═══════════════════════════════════════
   PHASE 3 — Product & Collection JS
   ═══════════════════════════════════════ */

/* ─── Filter Toggle ─── */
(function() {
  var toggle = document.querySelector('.filter-toggle');
  var panel = document.getElementById('collectionFilters');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function() {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !expanded);
    panel.setAttribute('aria-hidden', expanded);
  });
})();


/* ─── View Toggle (Grid / List) — handled in main IIFE ─── */


/* ─── Quick Add (AJAX) ─── */
(function() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.classList.contains('quick-add-form')) return;
    e.preventDefault();

    var btn = form.querySelector('.quick-add-btn');
    if (!btn || btn.classList.contains('is-adding')) return;

    btn.classList.add('is-adding');
    var originalText = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" class="spin-icon"><path d="M12 2a10 10 0 1 0 10 10"/></svg> Adding...';

    var formData = new FormData(form);
    var body = JSON.stringify({
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity')) || 1
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';

      // Update cart count in header
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var counts = document.querySelectorAll('.nav-cart-count, .cart-count, [data-cart-count]');
          counts.forEach(function(el) { el.textContent = cart.item_count; });
        });

      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.innerHTML = originalText;
      }, 2000);
    })
    .catch(function(err) {
      btn.classList.remove('is-adding');
      btn.innerHTML = 'Error – try again';
      setTimeout(function() { btn.innerHTML = originalText; }, 2000);
    });
  });

  // Spinning animation for loading
  var style = document.createElement('style');
  style.textContent = '@keyframes spin{to{transform:rotate(360deg)}}.spin-icon{animation:spin .6s linear infinite}';
  document.head.appendChild(style);
})();


/* ─── Product Image Zoom ─── */
(function() {
  var gallery = document.querySelector('.product-gallery');
  if (!gallery || gallery.dataset.zoomEnabled === 'false') return;

  var container = gallery.querySelector('[data-image-zoom]');
  var img = document.getElementById('mainProductImage');
  if (!container || !img) return;

  container.addEventListener('mousemove', function(e) {
    var rect = container.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    container.style.setProperty('--zoom-x', x + '%');
    container.style.setProperty('--zoom-y', y + '%');

    if (!container.hasAttribute('data-zoom-active')) {
      container.setAttribute('data-zoom-active', '');
    }
  });

  container.addEventListener('mouseleave', function() {
    container.removeAttribute('data-zoom-active');
  });

  // Toggle on click for mobile
  container.addEventListener('click', function(e) {
    if (e.target.closest('.product-badge-large')) return;
    if (container.hasAttribute('data-zoom-active')) {
      container.removeAttribute('data-zoom-active');
    } else {
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      container.style.setProperty('--zoom-x', x + '%');
      container.style.setProperty('--zoom-y', y + '%');
      container.setAttribute('data-zoom-active', '');
    }
  });
})();


/* ─── Product Popup ─── */
(function() {
  document.addEventListener('click', function(e) {
    // Open
    var trigger = e.target.closest('.product-popup-trigger');
    if (trigger) {
      e.preventDefault();
      var id = trigger.dataset.popupId;
      var popup = document.getElementById(id);
      if (popup) {
        /* Move popup to body to escape sticky/transform parents */
        if (popup.parentElement !== document.body) {
          document.body.appendChild(popup);
        }
        /* Reset any residual inline styles from previous opens */
        popup.style.cssText = '';
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    // Close button
    var closeBtn = e.target.closest('.product-popup-close');
    if (closeBtn) {
      var overlay = closeBtn.closest('.product-popup-overlay');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      return;
    }

    // Click overlay to close
    if (e.target.classList.contains('product-popup-overlay')) {
      e.target.classList.remove('is-open');
      e.target.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  // Escape to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.product-popup-overlay.is-open');
      if (open) {
        open.classList.remove('is-open');
        open.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });
})();

/* ═══════════════════════════════════════
   PHASE 4 — Slideshow & Share Button JS
   ═══════════════════════════════════════ */

/* ─── Slideshow ─── */
(function() {
  document.querySelectorAll('[id^="slideshow-"]').forEach(function(slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    var dots = slideshow.querySelectorAll('.slideshow__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var timer = null;
    var autoRotate = slideshow.dataset.autoRotate === 'true';
    var speed = parseInt(slideshow.dataset.speed) * 1000 || 5000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function startAutoplay() {
      if (autoRotate && !timer) {
        timer = setInterval(function() { goTo(current + 1); }, speed);
      }
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Arrow buttons
    var prevBtn = slideshow.querySelector('[data-slide-prev]');
    var nextBtn = slideshow.querySelector('[data-slide-next]');
    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    // Dot buttons
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goTo(parseInt(dot.dataset.slideTo));
        startAutoplay();
      });
    });

    // Touch swipe
    var startX = 0;
    slideshow.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    slideshow.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        stopAutoplay();
        goTo(diff > 0 ? current + 1 : current - 1);
        startAutoplay();
      }
    });

    // Pause on hover
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();


/* ─── Share Button ─── */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.share-btn');
    if (!btn) return;
    e.preventDefault();

    var url = btn.dataset.shareUrl || window.location.href;
    var title = document.title;

    // Try native share first (mobile)
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function() {});
      return;
    }

    // Fallback: copy to clipboard
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function() {
        var original = btn.innerHTML;
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Copied!';
        setTimeout(function() { btn.innerHTML = original; }, 2000);
      });
    }
  });
})();


/* ═══════════════════════════════════════
   PHASE 5 — Luxury Animations
   Split-letter reveals & card staggers
   ═══════════════════════════════════════ */

(function() {
  'use strict';

  // Bail if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ── Split-Letter Reveal ──
  // Finds .section-title elements, splits text into individual <span> characters
  // IntersectionObserver triggers cascading reveal on scroll

  function splitTextIntoChars(el) {
    var text = el.textContent.trim();
    if (!text) return;

    // Store original text for screen readers
    el.setAttribute('aria-label', text);
    el.innerHTML = '';

    for (var i = 0; i < text.length; i++) {
      var span = document.createElement('span');
      span.className = 'split-char' + (text[i] === ' ' ? ' is-space' : '');
      span.setAttribute('aria-hidden', 'true');

      if (text[i] === ' ') {
        span.innerHTML = '&nbsp;';
      } else {
        span.textContent = text[i];
      }

      // Stagger delay: each char 30ms after the previous
      span.style.transitionDelay = (i * 30) + 'ms';
      el.appendChild(span);
    }

    // Remove the old .reveal class (we handle our own animation)
    el.classList.remove('reveal');
    el.classList.add('split-title');
  }

  // Find and split all section titles
  var sectionTitles = document.querySelectorAll('.section-title');
  sectionTitles.forEach(function(title) {
    // Don't split if it contains child elements (links, etc.)
    if (title.children.length > 0 && !title.querySelector('.split-char')) return;
    splitTextIntoChars(title);
  });

  // Also split collection hero h1
  var collectionH1 = document.querySelector('.collection-hero h1');
  if (collectionH1 && collectionH1.children.length === 0) {
    splitTextIntoChars(collectionH1);
    // Trigger immediately since it's above the fold
    setTimeout(function() { collectionH1.classList.add('visible'); }, 200);
  }

  // Also split hero h1 (homepage main title)
  var heroH1 = document.querySelector('.hero h1');
  if (heroH1 && heroH1.children.length === 0) {
    splitTextIntoChars(heroH1);
    // Trigger with delay to sequence after crest animation
    setTimeout(function() { heroH1.classList.add('visible'); }, 600);
  }

  // ── IntersectionObserver for Split Titles ──
  if ('IntersectionObserver' in window) {
    var titleObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Trigger the label first (if sibling)
          var header = entry.target.closest('.section-header');
          if (header) {
            var label = header.querySelector('.section-label');
            if (label) {
              label.classList.add('reveal-fade', 'visible');
            }
          }

          // Then trigger the split title after a small delay
          setTimeout(function() {
            entry.target.classList.add('visible');
          }, 150);

          // Then trigger description if present
          if (header) {
            var desc = header.querySelector('.section-description');
            if (desc) {
              desc.classList.add('section-desc-reveal', 'visible');
            }
          }

          titleObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.split-title').forEach(function(el) {
      // Skip collection hero (handled above)
      if (!el.closest('.collection-hero')) {
        titleObserver.observe(el);
      }
    });
  }

  // ── Card Stagger Reveals ──
  // Observe grids, add .cards-revealed when they scroll into view

  if ('IntersectionObserver' in window) {
    var gridObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cards-revealed');
          gridObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -40px 0px'
    });

    // Product grids
    document.querySelectorAll('.products-grid').forEach(function(grid) {
      gridObserver.observe(grid);
    });

    // Collection grids (homepage)
    document.querySelectorAll('.collections-grid').forEach(function(grid) {
      gridObserver.observe(grid);
    });

    // Workshop cards
    document.querySelectorAll('.workshop-grid').forEach(function(grid) {
      gridObserver.observe(grid);
    });
  }

  // ── Shopify Section Rendering (editor support) ──
  // When sections are re-rendered in the editor, re-init animations
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target;

      // Re-split titles
      section.querySelectorAll('.section-title').forEach(function(title) {
        if (title.children.length === 0) {
          splitTextIntoChars(title);
          title.classList.add('visible'); // Show immediately in editor
        }
      });

      // Show cards immediately in editor
      section.querySelectorAll('.products-grid, .collections-grid, .workshop-grid').forEach(function(grid) {
        grid.classList.add('cards-revealed');
      });
    });
  }

  // ── Safety Net ──
  // If IntersectionObserver never fires (rare edge case), force visible after 5s
  setTimeout(function() {
    document.querySelectorAll('.split-title:not(.visible)').forEach(function(el) {
      el.classList.add('visible');
    });
    document.querySelectorAll('.products-grid:not(.cards-revealed), .collections-grid:not(.cards-revealed), .workshop-grid:not(.cards-revealed)').forEach(function(grid) {
      grid.classList.add('cards-revealed');
    });
  }, 5000);

})();


/* ═══════════════════════════════════════
   PHASE 6 — Hero Parallax Depth
   ═══════════════════════════════════════ */

(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var hero = document.querySelector('.hero');
  if (!hero) return;

  var heroContent = hero.querySelector('.hero-content');
  var heroBg = hero.querySelector('.hero-bg-pattern');
  if (!heroContent) return;

  // Only parallax while hero is in view
  var heroInView = true;

  // Scroll parallax — content moves up slower than scroll, bg even slower
  var scrollTicking = false;
  window.addEventListener('scroll', function() {
    if (!scrollTicking) {
      requestAnimationFrame(function() {
        var scrollY = window.scrollY;
        var heroHeight = hero.offsetHeight;

        if (scrollY < heroHeight * 1.2) {
          heroInView = true;
          var progress = scrollY / heroHeight; // 0 at top, 1 at hero bottom

          // Content rises slower — creates depth
          heroContent.style.transform = 'translateY(' + (scrollY * 0.3) + 'px) scale(' + (1 - progress * 0.05) + ')';
          heroContent.style.opacity = Math.max(0, 1 - progress * 1.2);

          // Background pattern moves slower still
          if (heroBg) {
            heroBg.style.transform = 'translateY(' + (scrollY * 0.1) + 'px)';
          }
        } else if (heroInView) {
          heroInView = false;
        }

        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // Mouse tilt on hero — subtle 3D rotation following cursor
  hero.addEventListener('mousemove', function(e) {
    if (window.scrollY > hero.offsetHeight * 0.5) return; // Skip if scrolled past

    var rect = hero.getBoundingClientRect();
    var centerX = rect.width / 2;
    var centerY = rect.height / 2;
    var mouseX = e.clientX - rect.left;
    var mouseY = e.clientY - rect.top;

    // Normalize to -1 to 1
    var rotateY = ((mouseX - centerX) / centerX) * 1.5; // Max 1.5deg
    var rotateX = ((centerY - mouseY) / centerY) * 1; // Max 1deg

    heroContent.style.transform = 'translateY(' + (window.scrollY * 0.3) + 'px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
  });

  hero.addEventListener('mouseleave', function() {
    heroContent.style.transform = 'translateY(' + (window.scrollY * 0.3) + 'px)';
  });

})();


/* ═══════════════════════════════════════
   PHASE 7 — Magnetic Cursor on Buttons
   ═══════════════════════════════════════ */

(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Only on non-touch devices
  if ('ontouchstart' in window) return;

  var strength = 0.3; // How strongly the button follows cursor (0-1)
  var threshold = 80; // Pixels — proximity zone around button

  function initMagneticButton(btn) {
    btn.addEventListener('mousemove', function(e) {
      var rect = btn.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;

      var distX = e.clientX - centerX;
      var distY = e.clientY - centerY;
      var distance = Math.sqrt(distX * distX + distY * distY);

      if (distance < threshold) {
        btn.classList.add('magnetic-active');
        var pull = 1 - (distance / threshold); // Stronger when closer
        btn.style.transform = 'translate(' + (distX * strength * pull) + 'px, ' + (distY * strength * pull) + 'px)';
      }
    });

    btn.addEventListener('mouseleave', function() {
      btn.classList.remove('magnetic-active');
      btn.style.transform = '';
    });
  }

  // Apply to all .btn elements and CTAs
  document.querySelectorAll('.btn, .hero-cta a, .checkout-btn, .quick-add-btn').forEach(initMagneticButton);

  // Re-init on section load (editor)
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('.btn, .checkout-btn, .quick-add-btn').forEach(initMagneticButton);
    });
  }

})();

/* ========== HERO IMAGE SLIDESHOW ========== */
(function() {
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  if (slides.length < 2) return;

  var current = 0;
  var speed = 7000;
  var heroEl = document.querySelector('.hero');
  if (heroEl && heroEl.querySelector('[data-slide-speed]')) {
    speed = parseInt(heroEl.querySelector('[data-slide-speed]').value) * 1000;
  }

  function goToSlide(n) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  var timer = setInterval(function() { goToSlide(current + 1); }, speed);

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      clearInterval(timer);
      goToSlide(i);
      timer = setInterval(function() { goToSlide(current + 1); }, speed);
    });
  });
})();
